export default {
  pt: {
    title: "Continue pelo seu celular",
    qrHelperText: "Ou copie o link",
    copyLinkButton: "Copiar link da jornada",
    copyLinkSuccessTitle: "Link copiado!",
    copyLinkSuccessDescription: "Cole o link no navegador do seu celular para continuar.",
    copyLinkErrorTitle: "Não foi possível copiar",
    copyLinkErrorDescription: "Tente novamente ou use o QR-Code.",
  },
  en: {
    title: "Continue on your phone",
    qrHelperText: "Or copy the link",
    copyLinkButton: "Copy journey link",
    copyLinkSuccessTitle: "Link copied!",
    copyLinkSuccessDescription: "Paste the link in your phone's browser to continue.",
    copyLinkErrorTitle: "Couldn't copy",
    copyLinkErrorDescription: "Try again or use the QR-Code.",
  },
};
